<template>
    <section>
        <AgendaViewer></AgendaViewer>
    </section>
</template>

<script setup>
import AgendaViewer from "~/components/agenda/AgendaViewer.vue";

definePageMeta({
    layout: 'public-min'
});
</script>

